/**
 * Brazilian Portuguese (pt-BR) mappings for UpgradeNotice
 */

export const upgradeNoticePtBR = {
  // Cost banner
  "Just $1.99 gets you another analysis!": "Apenas R$ 11 para mais uma análise!",

  // New Modal Copy
  "Limit Hit": "Limite Atingido",
  "body_text": "Você atingiu o limite das jogadas grátis de hoje.\nSeu saldo será reiniciado em {hoursUntilReset} horas.",
  "offer_section": "Apenas R$11 → desbloqueie 2x mais análises de IA ou 3x QuickPicks\nUse StarCoins para continuar jogando!\nVá de Pro para 40x chats de IA por dia.",
  "Your call. Your game.": "Sua escolha. Seu jogo.",

  // Old Titles (kept for backwards compatibility)
  "Daily Message Limit Reached": "Limite Diário de Mensagens Atingido",
  "Message Limit Reached": "Limite de Mensagens Atingido",

  // Descriptions - these need special handling due to dynamic content
  "daily_limit_description_pro": "Você usou todas as {dailyLimit} mensagens diárias pro. Clique no ícone StarCoin na sua Janela de Chat para mais Poder!",
  "daily_limit_description_basic": "Você atingiu seu limite de {dailyLimit} mensagens.",
  
  // Time messages
  "Messages reset in": "Mensagens reiniciam em",
  "hours": "horas",
  
  // Buttons
  "Ask Another Question for 5 Star Coins": "Faça Outra Pergunta por 11 Moedas Estrela",
  "Buy Star Coins to Continue": "Comprar Moedas Estrela para Continuar",
  "Use Star Coins to Continue": "Usar Moedas Estrela para Continuar",
  "Buy Star Coins": "Comprar Moedas Estrela",
  "Continue with Star Coins": "Continuar com Moedas Estrela",
  "Upgrade to Pro": "Atualizar para Pro",
  "Got it": "Entendi",
  "Continue in Basic": "Continuar no Básico",
  
  // Info messages
  "5 Star Coins per question • No subscription needed": "11 Moedas Estrela por pergunta • Sem necessidade de assinatura",
  "5 Star Coins per question • Works without a subscription!": "11 Moedas Estrela por pergunta • Funciona sem assinatura!",
  "Pro users get 40 AI insights daily • 5 Star Coins per extra question": "Usuários Pro recebem 40 insights de IA diariamente • 11 Moedas Estrela por pergunta extra",
  "Pro: 40 daily AI insights • Star Coins: 5 per question": "Pro: 40 insights de IA diários • Moedas Estrela: 11 por pergunta",
  "2 Star Coins per message • No subscription needed": "2 Moedas Estrela por mensagem • Sem necessidade de assinatura",
  "Star Coins work without a subscription!": "Moedas Estrela funcionam sem assinatura!",
  "Pro users get 40 AI insights daily • Star Coins for extra usage": "Usuários Pro recebem 40 insights de IA diariamente • Moedas Estrela para uso extra",
  "Pro: 40 daily AI insights • Star Coins: Pay per use": "Pro: 40 insights de IA diários • Moedas Estrela: Pague por uso",
  
  // Aria labels
  "Close": "Fechar"
};